import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Input, P, Small, theme } from '@upsolve/ui';
import { ERROR_CODES } from '@upsolve/shared';

import InputRow from '../Inputs/InputRow.div';
import submitNewsletterSignup from './submitNewsletterSignup';
import validateEmail from '../utils/validateEmail';
import withViewportWatch from '../analytics/withViewportWatch';
import trackComponentImpression from '../analytics/trackComponentImpression';
import trackComponentAction from '../analytics/trackComponentAction';

const trackingProps = {
  componentName: 'CTANewsletterSignup',
  componentVersion: 0,
};

const CTANewsletterSignupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > div {
  }
  .newsletter-input-row {
    margin-left: 0.5em;
    width: 45%;
    small {
      font-size: 10px;
    }
  }
  p {
    font-size: 16px;
  }
  @media (max-width: 45em) {
    flex-direction: column;
    .newsletter-input-row {
      width: 100%;
      margin: 0;
    }
  }
`;

const CTANewsletterMessageWrapper = styled.div`
  .newsletter-msg {
    width: 100%;
    p {
      width: 100%;
      text-align: center;
    }
  }
  .newsletter-submit-success p {
    color: ${theme.colors.green[100]}
  }
  .newsletter-submit-error p {
    color: ${theme.colors.red[500]}
  }
`

class CTANewsletterSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: null,
      impressionTracked: false,
      submitted: false,
    };
  }

  async handleSubmit() {
    trackComponentAction({
      ...trackingProps,
      actionId: 'ctaNewsletterSignup.newsletterSignup',
      actionMethod: 'click',
    });

    if (this.state.submitted) {
      return;
    }
    const { email } = this.state;
    const { isValid, error } = await validateEmail(email);

    if (!isValid) {
      this.setState({ error, submitted: false });
      return;
    }

    try {
      await submitNewsletterSignup(email)
      this.setState({ submitted: true, error: null });
    } catch (e) {
      this.setState({
        submitted: false,
        error: ERROR_CODES.UNHANDLED,
      });
    }
  }

  render() {
    const { submitted, error, impressionTracked } = this.state;

    if (this.props.isInViewport && !impressionTracked) {
      this.props.stopWatcher();
      trackComponentImpression(trackingProps)
        .then(() => this.setState({ impressionTracked: true }));
    }

    return (
      <div>
        <CTANewsletterSignupWrapper>
          <div className="newsletter-label">
            <P><b>Receive our definitive guide on bankruptcy in 2020.<br />Everything you need to know during COVID-19.</b></P>
          </div>
          <div className="newsletter-input-row">
            <InputRow>
              <Input
                placeholder="Enter your email"
                size="sm"
                onChange={event => this.setState({ email: event.target.value })}
              />
              <Button
                disabled={this.state.submitted}
                size="sm"
                onClick={() => this.handleSubmit()}
              >
                Get Access
              </Button>
            </InputRow>
            <Small>Unsubscribe anytime</Small>
          </div>
        </CTANewsletterSignupWrapper>
        <CTANewsletterMessageWrapper>
          {submitted && (
            <div className="newsletter-msg newsletter-submit-success">
              <P>Success!</P>
            </div>
          )}
          {error != null && (
            <div className="newsletter-msg newsletter-submit-error">
              <P>
                {(() => ({
                  [ERROR_CODES.INVALID_EMAIL]: 'Invalid e-mail address',
                  [ERROR_CODES.FILER_EXISTS]: 'Already signed up!',
                  [ERROR_CODES.UNHANDLED]: 'Error. Please try back later!',
                }[error]))()}
              </P>
            </div>
          )}
        </CTANewsletterMessageWrapper>
      </div>
    );
  }
}

export default withViewportWatch(CTANewsletterSignup);
